<section class="article-list mt-4">
  <h1 class="mb-3 text-xl font-semibold text-text">Manage Collection</h1>

  @if (isLoading()) {
    <p class="text-sm text-text-muted">Loading collection...</p>
  } @else if (!canManage()) {
    <p class="text-sm text-text-muted">{{ loadErrorMessage() }}</p>
  } @else if (loadedCollection(); as collection) {
    <app-collection-list-card
      [collection]="collection"
      [showCollectionTitle]="true"
      [showManagementActions]="true"
    ></app-collection-list-card>
  }
</section>
